import React from 'react';
import { useParams } from 'react-router-dom';

import CardHeader from '../../../common/Labels/CardHeader';
import CardView from '../../../common/CardView/CardView';

import LogsPanel from '../../../LogsPanel/LogsPanel';
import TimeRangePicker from '../../../TimeRangePicker/TimeRangePicker';

import { usePreferredTimeRange } from '../../../contexts/TimeRangeContext/TimeRangeContext';

import InferenceLatencyChart from '../../../charts/prefabs/InferenceLatencyChart';
import InferenceRateChart from '../../../charts/prefabs/InferenceRateChart';
import RequestPerSecondChart from '../../../charts/prefabs/RequestPerSecondChart';

import usePipelineData from '../../PipelineDataContext';

export const PipelineMetricsTab = () => {
  const routeParams = useParams();

  const { pipeline } = usePipelineData();
  const {
    startTimestamp,
    endTimestamp,
    step,
    selectedTimeRange,
    onTimeRangeChange,
  } = usePreferredTimeRange()

  const labelFormatString = (endTimestamp - startTimestamp) > 24 * 60 * 60
    ? 'LLL d k:mm:ss'
    : 'k:mm:ss';

  return (
    <>
      <CardView>
        <CardHeader className="mb-2">Viewing Pipeline Data for {routeParams.id}</CardHeader>
        <div className="flex flex-row">
          <TimeRangePicker selectedRange={selectedTimeRange} onChange={onTimeRangeChange} />
        </div>
      </CardView>
      <div className="grid grid-cols-1 gap-x-6 gap-y-3 mt-4 xl:grid-cols-2 grid-rows-chart-column xl:grid-rows-chart-grid">
        <RequestPerSecondChart
          chartID="requests-per-second"
          pipelineID={pipeline?.pipelineID}
          pipelineVersion={routeParams?.version}
          labelFormatString={labelFormatString}
          startTimestamp={startTimestamp}
          endTimestamp={endTimestamp}
          step={step}
        />
        <InferenceRateChart
          chartID="inference-rate"
          pipelineID={pipeline?.pipelineID}
          pipelineVersion={routeParams?.version}
          labelFormatString={labelFormatString}
          startTimestamp={startTimestamp}
          endTimestamp={endTimestamp}
          step={step}
        />
        <InferenceLatencyChart
          chartID="inference-latency"
          pipelineID={pipeline?.pipelineID}
          pipelineVersion={routeParams?.version}
          labelFormatString={labelFormatString}
          startTimestamp={startTimestamp}
          endTimestamp={endTimestamp}
          step={step}
        />
      </div>
      <div
        className="grid grid-cols-1 grid-rows-single-card gap-x-6 gap-y-3 mt-8"
      >
        <LogsPanel pipelineID={routeParams.id} />
      </div>
    </>
  )
}

export default PipelineMetricsTab;
